import { makeStyles } from 'tss-react/mui';

const useStylesListItem: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  listItem: {
    padding: '10px !important',
    borderBottom: `1px solid ${theme.palette.info.main}`,
    '&:nth-of-type(even)': {
      backgroundColor: theme.palette.primary.light,
    },
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  listItemActive: {
    backgroundColor: `${theme.palette.secondary.light} !important`,
  },
  listItemExtended: {
    padding: '10px 15px !important',
  },
  listItemContentSpread: {
    justifyContent: 'space-between !important',
  },
  listItemCompleted: {
    backgroundColor: `${theme.palette.success.light} !important`,
  },
  listItemButton: {
    '&:hover': {
      backgroundColor: `${theme.palette.info.light} !important`,
    },
  },
}));

export default useStylesListItem;
